import axios from "@/utils/request";

export function getAxiosOption(data, params, config) {
  return axios
    .get(`/productComment/web/praise`, { params })
    .then(res => res.data);
}

export function getListResourceInfo(data = {}, params) {
  return axios
    .get(`/productResource/web/listResourceInfo`, { params })
    .then(res => res.data);
}

export function getFindByCodeInfo(data = {}, params) {
  return axios
    .post(`/product/web/findByCode`, data, { params })
    .then(res => res.data);
}

export function getFindAppByCode(data = {}, params) {
  return axios
    .post(`api/product/web/findByCode`, data, { params })
    .then(res => res.data);
}
//用户评价
export function getUserCommont(data = {}, params) {
  return axios
    .get(`/productComment/web/page`, { params })
    .then(res => res.data);
}
//目录数据
export function getResCatalogs(data = {}, params) {
  return axios
    .get(`/resource/web/resCatalogs`, { params })
    .then(res => res.data);
}
//我的足迹
export function getBrowseRecord(data = {}, params) {
  return axios.get(`/browseRecord/web/page`, { params }).then(res => res.data);
}
//相关推荐
export function getProductRecomList(data = {}, params) {
  return axios
    .get(`/productRecom/web/productRecomList`, { params })
    .then(res => res.data);
}

//加入购物车
export function addShoppingCart(data = {}, params) {
  return axios.post(`/shoppingCart/web/save`, data).then(res => res.data);
}

//微信参数请求
export function wxMiniPay(data = {}, params) {
  return axios
    .post(`/onlinePay/web/wxMiniPay`, data, {
      params
    })
    .then(res => res.data);
}

//更新收货地址
export function updateByAddressId(data = {}, params) {
  return axios
    .post(`/UserAddress/updateByAddressId`, data, {
      params
    })
    .then(res => res.data);
}

//设置默认收货地址
export function UserAddressDefault(data = {}, params) {
  return axios
    .post(`/UserAddress/isDefault`, data, {
      params
    })
    .then(res => res.data);
}
//查询收货地址信息
export function selectUserAddressByAddressID(data = {}, params) {
  return axios
    .post(`/UserAddress/selectUserAddressByAddressID`, data, {
      params
    })
    .then(res => res.data);
}
//删除收货地址
export function delectUserAddressByAddressId(data = {}, params) {
  return axios
    .post(`/UserAddress/delectUserAddressByAddressId`, data, { params })
    .then(res => res.data);
}

//获取城市数据
export function selectRegion(data = {}, params) {
  return axios
    .post(`/region/selectRegion`, data, { params })
    .then(res => res.data);
}

//获取用户城市地址
export function findRegion(data = {}, params) {
  return axios
    .post(`/region/findRegion`, data, { params })
    .then(res => res.data);
}

//获取商品圈子列表
export function circlePage(data = {}, params) {
  return axios
    .post(`/circle/web/circleByCode`, data, { params })
    .then(res => res.data);
}
// circleList

//圈子邀请码加入请求
export function joinCircle(data = {}, params) {
  return axios
    .post(`/inviteCode/web/exchange`, data, { params })
    .then(res => res.data);
}

//用户收藏/取消收藏
export function collectProductAsyncSend(data = {}, params) {
  return axios
    .post(`api/collectProduct/web/asyncSend`, data, { params })
    .then(res => res.data);
}

//商品关联增值包
export function productPackageWebPage(data = {}, params) {
  //分页
  // return axios.post(`/productPackage/web/page`,data, { params }).then(res => res.data)
  //不分页
  return axios
    .post(`/productPackage/web/list`, data, { params })
    .then(res => res.data);
}

//课件下载请求
export function resourceDownload(data = {}, params) {
  return axios.get(`/resource/web/download`, { params }).then(res => res.data);
}

//搜索资源

export function searchGroupResource(data = {}, params) {
  return axios
    .post(`/search/web/searchGroupResResource`, data, { params })
    .then(res => res.data);
}

//h5搜索分类数据获取
export function getSaleClass(params) {
  return axios.get(`/saleClass/list`, { params }).then(res => res.data);
}

//热词搜索
export function getHotKeyWords(params) {
  return axios.get(`/searchLog/hotKeyWords`, { params }).then(res => res.data);
}



//签到
export function getSignIn(data,params){
  return axios.post(`/userAccumulate/web/signIn`,data,{params}).then(res=>res.data)
}
//用户获取积分以及今日积分任务完成记录
export function getUserAccounment(data,params){
  return axios.post(`/userAccumulate/web/findByToken`,data,{params}).then(res=>res.data)
}


// WEBPACK FOOTER //
// ./src/api/publishOnline.js